import React, { useEffect, useState } from 'react';
import List from '@mui/material/List';
import HorizontalGroup from './HorizontalGroup';
import HorizontalCollapse from './HorizontalCollapse';
import HorizontalItem from './HorizontalItem';
import Divider from '@mui/material/Divider';
import HorizontalNonGroup from './HorizontalNonGroup';
import { useAuthUser, useRoleUser } from '@crema/utility/AuthHooks';
import { routesConfig, adminRoutes, operatorRoutes, viewerRoutes, operatorEselon1Routes, penilaian360Routes } from '../../../../../pages/routesConfig';

const HorizontalNav = () => {
  const [menu, setMenu] = useState([])
  const { user } = useAuthUser()
  const { currentRole } = useRoleUser()

  // check currentRole dan set menu sesuai role
  useEffect(() => {
    let tmpMenu = []
    if (currentRole?.id === 'SIPEG_PEGAWAI') {
      // sign url from api for talent management menu
      tmpMenu = routesConfig.map((item) => {
        if (item?.id === 'talent-management-pegawai') {
          return {
            ...item,
            url: user?.tmt_access
          }
        }

        return { ...item }
      })
    } else if (currentRole?.id === 'SIPEG_ADMINISTRATOR') {
      tmpMenu = adminRoutes
    } else if (currentRole?.id === 'SIPEG_OPERATOR') {
      tmpMenu = operatorRoutes
    } else if (currentRole?.id === 'SIPEG_VIEWER') {
      tmpMenu = viewerRoutes
    } else if (currentRole?.id === 'SIPEG_OPERATOR_ESELON_1') {
      tmpMenu = operatorEselon1Routes
    } else if (currentRole?.id.includes('360')) {
      tmpMenu = penilaian360Routes
    }

    setMenu(tmpMenu)
  }, [currentRole])

  return (
    <List className='navbarNav'>
      {(menu && menu.length > 0) &&
        menu.map((item) => (
          <React.Fragment key={item.id}>
            {item.type === 'group' && (
              <HorizontalGroup item={item} nestedLevel={0} />
            )}

            {item.type === 'collapse' && (
              <HorizontalCollapse item={item} nestedLevel={0} />
            )}

            {item.type === 'item' && (
              <HorizontalItem item={item} nestedLevel={0} />
            )}

            {item.type === 'nonGroup' && (
              <HorizontalNonGroup item={item} nestedLevel={0} />
            )}

            {item.type === 'divider' && <Divider sx={{ my: 5 }} />}
          </React.Fragment>
        ))
      }
    </List>
  );
};

export default HorizontalNav;
